import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Footer from './components/Footer/Footer';
import Main from './components/main/Main';

import './App.css';

 

function App() {
  return (
    <>
    
   <Header/>
   
<Footer/>
    </>
  )
}

export default App;
